import { Component, effect, inject } from '@angular/core';
import { AdvancedSearchComponent } from '@lib-ui/advanced-search/ui/advanced-search.component';
import { LoaderComponent } from '@lib-ui/loader/loader.component';
import { CommonTableComponent } from '@lib-ui/common-table/ui/common-table.component';
import { ICommonTableAction, ICommonTableConfig } from '@lib-ui/common-table/models/common-table.interface';
import { CommonTableConfig } from '@lib-ui/common-table/models/common-table-config.class';
import { RowAction } from '@lib-ui/common-table/models/common-table.enum';
import { LogsTableService } from './logs-table.service';
import { FilterConfig } from '@lib-ui/advanced-search/models/advanced-search.interface';
import { EnumService } from '@lib-services/enum.service';
import { UserActionEnum } from '@libs-enums/userActions.enum';
import { EntityNameEnum } from '@libs-enums/entityName.enum';
import { Location } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '@lib-services/session-storage.service';
import { MatIcon } from '@angular/material/icon';
import { Role } from '@libs-enums/role.enum';
import { TimeZoneService } from '@lib-services/time-zone.service';

@Component({
    selector: 'app-logs',
    standalone: true,
    imports: [
        AdvancedSearchComponent,
        LoaderComponent,
        CommonTableComponent,
        MatButton,
        MatIcon
    ],
    templateUrl: './logs.component.html',
    styleUrl: './logs.component.scss'
})
export class LogsComponent {
    protected enumService = inject(EnumService);
    protected logsTableService = inject(LogsTableService);
    protected sessionStorageService = inject(SessionStorageService);
    protected location = inject(Location);
    protected route = inject(ActivatedRoute);
    private timeZoneService = inject(TimeZoneService);

    showBackBtn = false;

    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'userId', title: 'ИН пользователя', withSort: true },
            { name: 'createdAt', title: 'Дата изменения', type: 'DateTime' },
            { name: 'user', title: 'Пользователь', withSort: true },
            { name: 'role', title: 'Роль', withSort: true },
            { name: 'action', title: 'Действие', withSort: true },
            { name: 'entityId', title: 'ИН сущности', withSort: true },
            { name: 'entityName', title: 'Сущность', withSort: true },
            {
                title: 'MetaData',
                name: 'body',
                type: 'metadata',
                showToolTip: true,
            },
        ],
    });
    filterConfig: FilterConfig[] = [
        {
            type: 'input',
            label: 'ИН сущности',
            name: 'entityId',
        },
        {
            type: 'input',
            label: 'Пользователь',
            name: 'user.firstName',
        },
        {
            type: 'dropdown',
            label: 'Роль',
            name: 'user.role',
            options: this.enumService.enumTranslateRoleToArrSelects(Role),
        },
        {
            type: 'dateRangePicker',
            label: 'Период',
            name: 'createdAt',
        },
        {
            type: 'dropdown',
            label: 'Действие',
            name: 'action',
            options: this.enumService.enumTranslateActionsToArrSelects(UserActionEnum),
        },
        {
            type: 'dropdown',
            label: 'Сущность',
            name: 'entityName',
            options: this.enumService.enumTranslateEntityNameArrSelects(EntityNameEnum),
        },
    ];

    constructor() {
        this.showBackBtn = this.route.snapshot.queryParams['showBackBtn'] ?? false;

        effect(() => {
            if (this.timeZoneService.currentTimeZone()) {
                this.applyFilters(this.tableConfig.filters as Record<string, string | null>);
            }
        }, { allowSignalWrites: true });
    }

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            // TODO открытьвать на новой странице или в диалоге
        }
    }

    applyFilters(filterData: Record<string, string | null>): void {

        const createdAt = this.sessionStorageService.getFiltersValues()['createdAt'];

        // преобразовываем время из фильтра в это же время на выбранной временной зоне
        if (createdAt) {
            const [dateFrom, dateTo] = createdAt.split(',');
            const processedDateFrom = this.timeZoneService.saveDateToCurrentTimeZone(dateFrom);
            const processedDateTo = this.timeZoneService.saveDateToCurrentTimeZone(dateTo);

            if (processedDateFrom && processedDateTo) {
                filterData['createdAt'] = `${processedDateFrom},${processedDateTo}`;
            }
        }
        this.tableConfig.filters = filterData;
        this.logsTableService.updateData(this.tableConfig);
        this.tableConfig.paginatorConfig.pageIndex = 0;
    }

    turnBack(): void {
        this.sessionStorageService.removeItem('logs-filters');
        this.location.back();
    }
}
